import { useState } from "react";
import StorageService from "../../service/StorageService";

const useStorage = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const storageService = new StorageService();

  const uploadFile = async (file, assetType, additionalData = {}) => {
    if (!file || typeof file !== "object") return;

    setUploading(true);
    setError(null);

    try {
      const result = await storageService.uploadFile(
        file,
        assetType,
        additionalData
      );
      return result;
    } catch (err) {
      setError(err.message || "Upload failed");
      throw err;
    } finally {
      setUploading(false);
    }
  };

  return {
    uploadFile,
    uploading,
    error,
  };
};

export default useStorage;
